import ECViewState from './viewStateHandler';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import { extendLoadingScreen } from 'mini-email-context/lib/handleLoadingExtension';
import { FeatureName, isFeatureEnabled } from 'owa-feature-flags';
import { loadConversation, loadItem } from 'mini-mail-load-conversation/lib/lazyIndex';
import { logUsage } from 'owa-analytics';
import { mailItemViewReadingPaneRouteEntryHandler } from './mailItemReadingPaneRouteHandler';
import { mailReadingPaneRouteHandler } from './mailReadingPaneRouteHandler';

import {
    generateId,
    generateItemId,
} from 'mini-mail-reading-pane-view/lib/utils/convertIDInEmailContext';
export interface MailReadingPaneRouteParameters {
    folderId: string;
    conversationId: string;
    itemId: string;
    immutableItemId: string;
}

export const emailContextValues = {
    ECPath: false,
    id: null,
    itemId: null,
    immutableItemId: null,
    idFound: false,
    itemFound: false,
};

export const emailContextIsOpen = {
    //Making it as a separate object should a need arise to do more than logging
    isOpen: false,
    shouldDelete: false,
    shouldReload: false,
    convId: [],
};

export function checkIfIdIsValidForDecoding(id: string, type = 0) {
    try {
        atob(id);
        return true;
    } catch (e) {
        logUsage('nonDecodableWin32ID', { id: id, idT: type }, { isCore: true });
        return false;
    }
}

/**
 * Created primarily for Email Context - as the same url is received, the check of whether to render in Item View or Conversation View is performed here.
 */
export async function mailViewHandler(params: MailReadingPaneRouteParameters): Promise<void> {
    logUsage(
        'emailContextUser',
        {
            fId: params.folderId,
            cId: params.conversationId,
            imId: params.immutableItemId,
            iId: params.itemId,
        },
        { isCore: true }
    );
    const id = generateId(params.conversationId);
    const itemId = generateItemId(params.itemId);
    const immutableItemId =
        params.itemId === params.immutableItemId
            ? generateItemId(params.immutableItemId)
            : params.immutableItemId; //When the immutableItemId is not present, the itemId replaces it. In this situation, it becomes necessary to encode the immutableItemId as well
    const folder = params.folderId;
    setECObjectValues(id, itemId, immutableItemId);
    emailContextIsOpen.isOpen = true;

    extendLoadingScreen();

    const isInItemView = isItemView();

    if (!isInItemView) await loadConversation(id);
    else
        isFeatureEnabled('fwk-immutable-ids' as FeatureName)
            ? await loadItem(immutableItemId)
            : await loadItem(itemId);

    if (!isInItemView && emailContextValues.idFound === false) {
        logUsage('renderInItemView', { cId: params.conversationId }, { isCore: true });
        ECViewState.setIsItemViewNeeded(true);
    } else if (isInItemView && emailContextValues.itemFound === false) {
        logUsage('renderInConversationView', { cId: params.conversationId }, { isCore: true });
        ECViewState.setRenderInConversationView(true);
    }
    ECViewState.shouldItemViewBeShown()
        ? await mailItemViewReadingPaneRouteEntryHandler({
              folderId: folder,
              itemId: itemId,
              immutableItemId: immutableItemId,
          })
        : await mailReadingPaneRouteHandler({
              folderId: folder,
              itemId: itemId,
              immutableItemId: immutableItemId,
              conversationId: id,
          });
}

function setECObjectValues(id: string, itemId: string, immutableItemId: string) {
    emailContextValues.ECPath = true;
    emailContextValues.id = id;
    emailContextValues.itemId = itemId;
    emailContextValues.immutableItemId = immutableItemId;
}
